import { Injectable } from "@angular/core";

export interface IUniversalResolverService {
    getSearchFields(type: string): Promise<SearchField[]>;
    getSearchItems(type: string, valueField: string, filters: SearchField[]): Promise<SearchItem[]>; 
    getItem(type: string, id: string, version: number, subversion: number): Promise<any>;
}

export class SearchField {
    fieldName: string;
    placeHolder: string;
    value: string;
}

export class SearchItem {
    id: string;
    version: number;
    subversion: number;

    value: string;
    title: string;
}

@Injectable({
    providedIn: 'root',
})
export class UniversalResolver implements IUniversalResolverService {
    private _service: IUniversalResolverService;

    public initialize(service: IUniversalResolverService): void {
        if (this._service) throw new Error("UniversalResolver may be initialized only once.");

        this._service = service;
    }

    getSearchFields(type: string): Promise<SearchField[]> {
        if (!this._service) throw new Error("UniversalResolver must be initialized before use.");

        return this._service.getSearchFields(type);
    } 

    getSearchItems(type: string, valueField: string, filters: SearchField[]): Promise<SearchItem[]> {
        if (!this._service) throw new Error("UniversalResolver must be initialized before use.");

        return this._service.getSearchItems(type, valueField, filters);
    }

    getItem(type: string, id: string, version: number, subversion: number): Promise<any> {
        if (!this._service) throw new Error("UniversalResolver must be initialized before use.");

        return this._service.getItem(type, id, version, subversion);
    }
}



// WEBPACK FOOTER //
// ./src/app/common/dynamic-form/universal/universal-resolver.ts